export default function TrustSection() {
  const trustItems = [
    {
      icon: "ri-refresh-line",
      title: "Updated Weekly",
      desc: "Product listings and seller information are refreshed every week to ensure you always have the latest data.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Product Verification",
      desc: "Every listing goes through a verification process based on community feedback and seller performance data.",
    },
    {
      icon: "ri-group-line",
      title: "Community Recommendations",
      desc: "Products are curated with input from thousands of buyers who share their experiences and honest reviews.",
    },
    {
      icon: "ri-eye-line",
      title: "Transparent Reviews",
      desc: "We maintain full transparency about our curation process — no hidden sponsorships or paid placements.",
    },
    {
      icon: "ri-database-2-line",
      title: "Independent Information",
      desc: "Our spreadsheet is independently maintained, free from seller influence, giving you unbiased product data.",
    },
    {
      icon: "ri-global-line",
      title: "Trusted Worldwide",
      desc: "Thousands of buyers around the world use our guides every month to make informed shopping decisions.",
    },
  ];

  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold uppercase tracking-wider mb-4">
            Why Trust Us
          </span>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
            Trusted by Buyers Worldwide
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            Content reviewed and updated regularly with independent editorial standards and user-focused recommendations
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {trustItems.map((item) => (
            <div
              key={item.title}
              className="p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-200 transition-colors duration-200"
            >
              <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center text-accent-600 mb-4">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="font-semibold text-foreground-900 text-sm mb-2">{item.title}</h3>
              <p className="text-foreground-500 text-xs leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}